// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content[data-v-0df4d933] {\n  background-color: #fff;\n  height: calc(100vh - 140px);\n}\n.content[data-v-0df4d933] .el-tabs__item {\n  padding: 0 12px;\n  margin-right: 0px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
